function Relationship() {
    return (
        <div className="w-2/6 h-full">
        <div className="w-full h-2/4 flex flex-col items-end justify-center text-white pt-9">
          <h3>پل های ارتباطی</h3>
          <div className="w-full flex justify-end relative top-5">
            <a href="https://t.me/amirhoseinm0">
              <i className="bx bxl-telegram text-4xl text-white transition-all ml-3"></i>
            </a>
            <a href="https://www.instagram.com/amir.hosein.09">
              <i className="bx bxl-instagram text-4xl text-white transition-all"></i>
            </a>
          </div>
        </div>
      </div>
    );
  }
  
  export default Relationship;  